// extracted by mini-css-extract-plugin
export default {"centeredTextBlock":"J_di9qC3TY9UZ7WDKo1J","largeIcon":"OrNAY9IBlswrhsJc2iOW"};